import {
  Box,
  Button,
  Flex,
  Heading,
  Link,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import HybridBottomSheetDrawer from "../../components/HybridBottomSheetDrawer";
import QueryStateWrapper from "../../components/QueryStateWrapper";
import { useLaundrette } from "../../data/laundrette.api";
import { useFocusOnFeature } from "../../hooks/useFocusOnFeature";
import { Feature } from "geojson";
import LaundryMachine from "../../components/laundrette/LaundryMachine";
import BackButton from "../../components/BackButton";
import FavouriteButton from "../../components/FavouriteButton";

type Props = {};

const ViewLaundrette = (props: Props) => {
  const { location } = useParams<{ location: string }>();
  const { data, isLoading, error, isSuccess } = useLaundrette(location);
  const bg = useColorModeValue("lancsBlue.50", "gray.800");

  const feature = useMemo((): Feature | undefined => {
    if (data) {
      return {
        type: "Feature",
        properties: {},
        geometry: data.details.mapData?.geometry ?? {
          type: "Point",
          coordinates: [data.details.lng, data.details.lat],
        },
      };
    }
  }, [data]);

  useFocusOnFeature(feature);

  const dryers = useMemo(() => {
    return (
      data?.appliances.appliances.filter(
        (appliance) => appliance.appliance_type === "D"
      ) ?? []
    );
  }, [data]);

  const washers = useMemo(() => {
    return (
      data?.appliances.appliances.filter(
        (appliance) => appliance.appliance_type === "W"
      ) ?? []
    );
  }, [data]);

  return (
    <HybridBottomSheetDrawer>
      <BackButton />
      <Box p={8}>
        <QueryStateWrapper isLoading={isLoading} error={error} data={data}>
          <Flex justify="space-between">
            <Heading size="md" mb={4} textTransform="capitalize">
              {data?.appliances.laundry_room_name.toLowerCase()}
            </Heading>
            <FavouriteButton
              name={`${data?.appliances.laundry_room_name.toLowerCase()}`}
            />
          </Flex>
          <Flex bg={bg} p={5} rounded="md" boxShadow="sm" mb={5}>
            <Stat>
              <StatLabel>Washers Free</StatLabel>
              <StatNumber>
                {washers.filter((w) => w.status !== "IN USE").length}
              </StatNumber>
            </Stat>
            <Stat>
              <StatLabel>Dryers Free</StatLabel>
              <StatNumber>
                {dryers.filter((d) => d.status !== "IN USE").length}
              </StatNumber>
            </Stat>
          </Flex>
          <Box mb={5}>
            <Heading size="sm" mb={2}>
              Washers
            </Heading>
            <Flex flexWrap={"wrap"}>
              {washers.map((appliance) => (
                <LaundryMachine appliance={appliance} />
              ))}
            </Flex>
          </Box>

          <Box mb={5}>
            <Heading size="sm" mb={2}>
              Dryers
            </Heading>
            <Flex flexWrap={"wrap"}>
              {dryers.map((appliance) => (
                <LaundryMachine appliance={appliance} />
              ))}
            </Flex>
          </Box>

          <Box mb={5}>
            <Heading size="sm" mb={2}>
              Washer and Dryer Availability
            </Heading>
          </Box>
        </QueryStateWrapper>
      </Box>
    </HybridBottomSheetDrawer>
  );
};

export default ViewLaundrette;
